// src/pages/About.jsx
import React from "react";
import { Container, Row, Col, Card, Badge, ListGroup, Button } from "react-bootstrap";
import { Link } from "react-router-dom";
import './About.css';


const About = () => {
  return (
    <Container className="py-5 about-page">
      {/* Encabezado */}
      <Row className="mb-4">
        <Col md={{ span: 10, offset: 1 }} lg={{ span: 8, offset: 2 }}>
          <h1 className="text-center mb-3">Acerca de <span className="text-primary">Farmacia Solidaria</span></h1>
          <p className="lead text-center text-muted">
            Conectamos <strong>personas que donan</strong> medicamentos en buen estado con
            <strong> quienes los necesitan</strong>, promoviendo el acceso, la transparencia y la reducción del desperdicio.
          </p>
        </Col>
      </Row>

      {/* Objetivo y Propósito */}
      <Row className="g-4 mb-4">
        <Col md={6}>
          <Card className="h-100 shadow-sm">
            <Card.Body>
              <Card.Title>¿Cuál es nuestro objetivo?</Card.Title>
              <Card.Text className="mb-2">
                <strong>Facilitar el acceso</strong> a tratamientos mediante el intercambio solidario de medicamentos
                donados, priorizando la seguridad, la trazabilidad y el uso responsable.
              </Card.Text>
              <Card.Text>
                Buscamos <strong>reducir el desperdicio</strong> y dar una segunda oportunidad a los medicamentos en buen
                estado que ya no serán utilizados, siempre cumpliendo con requisitos básicos de conservación y vigencia.
              </Card.Text>
              <Badge bg="success">Impacto Social</Badge>{" "}
              <Badge bg="info">Economía Circular</Badge>{" "}
              <Badge bg="secondary">Acceso</Badge>
            </Card.Body>
          </Card>
        </Col>

        <Col md={6}>
          <Card className="h-100 shadow-sm">
            <Card.Body>
              <Card.Title>¿Para qué sirve esta plataforma?</Card.Title>
              <ListGroup variant="flush">
                <ListGroup.Item>
                  <strong>Donantes:</strong> registran, editan y gestionan medicamentos disponibles.
                </ListGroup.Item>
                <ListGroup.Item>
                  <strong>Solicitantes:</strong> buscan, reservan y adjuntan receta cuando corresponde.
                </ListGroup.Item>
                <ListGroup.Item>
                  <strong>Seguimiento:</strong> ambas partes visualizan el estado de cada solicitud en tiempo real.
                </ListGroup.Item>
                <ListGroup.Item>
                  <strong>Noticias:</strong> el equipo publica novedades, guías y campañas desde el panel de administración.
                </ListGroup.Item>
              </ListGroup>
            </Card.Body>
          </Card>
        </Col>
      </Row>

      {/* Funcionalidades */}
      <Row className="g-4 mb-4">
        <Col md={4}>
          <Card className="h-100 shadow-sm">
            <Card.Body>
              <Card.Title>Perfiles y accesos</Card.Title>
              <ul className="mb-0">
                <li className="mb-2"><strong>Donante:</strong> publica medicamentos y responde solicitudes.</li>
                <li className="mb-2"><strong>Solicitante:</strong> explora catálogo y realiza pedidos.</li>
                <li className="mb-0"><strong>Superadmin:</strong> administra noticias y supervisa el flujo general.</li>
              </ul>
            </Card.Body>
          </Card>
        </Col>
        <Col md={4}>
          <Card className="h-100 shadow-sm">
            <Card.Body>
              <Card.Title>Gestión de solicitudes</Card.Title>
              <ul className="mb-0">
                <li className="mb-2">Estados: <strong>pendiente</strong>, <strong>en revisión</strong>, <strong>aprobada</strong>, <strong>rechazada</strong>, <strong>completada</strong>.</li>
                <li className="mb-2">Carga opcional/obligatoria de receta según el caso.</li>
                <li className="mb-0">Trazabilidad completa con fecha y actualización de estado.</li>
              </ul>
            </Card.Body>
          </Card>
        </Col>
        <Col md={4}>
          <Card className="h-100 shadow-sm">
            <Card.Body>
              <Card.Title>Comunicación y avisos</Card.Title>
              <ul className="mb-0">
                <li className="mb-2">Notificaciones dentro de la plataforma para cambios de estado.</li>
                <li className="mb-2">Emails automáticos de bienvenida y seguimiento del flujo.</li>
                <li className="mb-0">Canal de noticias para campañas, guías y novedades.</li>
              </ul>
            </Card.Body>
          </Card>
        </Col>
      </Row>

      {/* Cómo funciona */}
      <Row className="g-4 mb-4">
        <Col lg={7}>
          <Card className="h-100 shadow-sm">
            <Card.Body>
              <Card.Title>Cómo funciona</Card.Title>
              <ol className="mb-0">
                <li className="mb-2">
                  <strong>Registro:</strong> creás tu cuenta como donante o solicitante.
                </li>
                <li className="mb-2">
                  <strong>Publicación/Reserva:</strong> donantes cargan medicamentos; solicitantes exploran “Medicamentos Disponibles” y reservan.
                </li>
                <li className="mb-2">
                  <strong>Verificación:</strong> si el medicamento lo requiere, el solicitante sube su <em>receta médica</em>.
                </li>
                <li className="mb-2">
                  <strong>Aprobación y Entrega:</strong> el donante aprueba la solicitud y coordinan la entrega.
                </li>
                <li>
                  <strong>Cierre:</strong> marcan la solicitud como <em>completada</em> para mantener la trazabilidad.
                </li>
              </ol>
            </Card.Body>
          </Card>
        </Col>

        <Col lg={5}>
          <Card className="h-100 shadow-sm">
            <Card.Body>
              <Card.Title>Principios de seguridad</Card.Title>
              <ul className="mb-0">
                <li className="mb-2">Solo se aceptan medicamentos en <strong>buen estado</strong> y con <strong>fecha vigente</strong>.</li>
                <li className="mb-2">Se solicita <strong>receta</strong> cuando la normativa o el tipo de medicamento lo requiere.</li>
                <li className="mb-2">Los datos personales se tratan con <strong>confidencialidad</strong>.</li>
                <li className="mb-0">Promovemos el uso responsable: esta plataforma <strong>no reemplaza</strong> la consulta médica.</li>
              </ul>
            </Card.Body>
          </Card>
        </Col>
      </Row>

      {/* Preguntas frecuentes */}
      <Row className="g-4 mb-4">
        <Col>
          <Card className="shadow-sm">
            <Card.Body>
              <Card.Title>Preguntas frecuentes</Card.Title>

              <div className="mb-3">
                <strong>¿Tiene costo?</strong>
                <p className="mb-0">No. Es un servicio solidario y gratuito.</p>
              </div>

              <div className="mb-3">
                <strong>¿Qué medicamentos puedo donar?</strong>
                <p className="mb-0">
                  Aquellos cerrados o en excelente estado de conservación, con fecha de vencimiento vigente y
                  etiquetado legible. Evitamos productos abiertos o sin información clara.
                </p>
              </div>

              <div className="mb-3">
                <strong>¿Siempre necesito receta?</strong>
                <p className="mb-0">
                  Solo para los que la legislación exige. La plataforma te pedirá adjuntarla cuando corresponda.
                </p>
              </div>

              <div className="mb-0">
                <strong>¿La plataforma vende medicamentos?</strong>
                <p className="mb-0">
                  No. Facilitamos el <em>encuentro solidario</em> entre donantes y solicitantes. No hay transacciones comerciales.
                </p>
              </div>

              <div className="mt-3 mb-0">
                <strong>¿Recibo avisos del estado de mi solicitud?</strong>
                <p className="mb-0">
                  Sí. Cada cambio de estado genera notificaciones en la app y avisos por correo electrónico.
                </p>
              </div>
            </Card.Body>
          </Card>
        </Col>
      </Row>

      {/* CTA */}
      <Row className="mt-2">
        <Col className="text-center">
          <Button as={Link} to="/login" size="lg" variant="primary" className="me-2">
            Crear cuenta
          </Button>
          <Button as={Link} to="/home" size="lg" variant="outline-success" className="me-2">
            Ver medicamentos
          </Button>
          <Button as={Link} to="/noticias" size="lg" variant="outline-primary">
            Ver noticias
          </Button>
        </Col>
      </Row>
    </Container>
  );
};

export default About;
